export const MENU_CHANGE_REUQESETED = 'COMMON/MENU_CHANGE_REUQESETED'
export const MENU_CHANGE_SUCCESS = 'COMMON/MENU_CHANGE_SUCCESS'
export const MENU_CHANGE_FAILED = 'COMMON/MENU_CHANGE_FAILED'

export const COURSE_REQUEST = 'COMMON/COURSE_REQUEST'
export const COURSE_SUCCESS = 'COMMON/COURSE_SUCCESS'
export const COURSE_FAILED = 'COMMON/COURSE_FAILED'

export const COURSE_DETAIL_REQUEST = 'COMMON/COURSE_DETAIL_REQUEST'
export const COURSE_DETAIL_SUCCESS = 'COMMON/COURSE_DETAIL_SUCCESS'
export const COURSE_DETAIL_FAILED = 'COMMON/COURSE_DETAIL_FAILED'

